import MainTitle from "./mainTitle";

export default MainTitle;
